import React, {Component} from 'react';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Platform,
  Alert,
  Dimensions,
  Image,
  FlatList,
} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import PropTypes from 'prop-types';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import networkService from '../../Network/NetworkManager';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import {AppToast} from '../../HelperClasses/AppToast';
import Switch from 'react-switch';
import {
  addMixpanelEvent,
  MixpanelEvent,
  revenuModelMixPanelEvent,
} from '../../Models/MixPannelEnum';
import SaveButton from '../../Component/SaveButton';
import closeIcon from '../../assets/closeBlackIcon.png';
import SettingStyleSheet from '../../StyleSheets/SettingStyleSheet';
import HeaderView from '../HeaderView';
import CommonStyleSheet from '../../StyleSheets/CommonStyleSheet';
import downArrow_Icon from '../../assets/downArrowIcon.png';
import {withLocale} from '../../Localization/LocaleContext';
import {clearSubscriptionDraft, readSubscriptionConfigDraft, subscriptionConfigDraftKey, writeSubscriptionConfigDraft} from './subscriptionDrafts';

const AppConstants = require('../../Constants/AppConstants');

const APPURL = require('../../Constants/URLConstants');
let KeyGroup = 'payments';
let AccountTypesArray = ['Standard', 'Express'];

const windowWidth = Dimensions.get('window').width;
let fixedWidth = AppConstants.mobileMaxWidth;

let itsMobileView = windowWidth < fixedWidth ? true : false;

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.draftKey = subscriptionConfigDraftKey();
    this.savedDraft = readSubscriptionConfigDraft(this.draftKey);
    this.state = {
      updateUI: false,
      dataLoad: false,
      hideShowPublickey: false,
      hideShowSecretkey: false,
      switchValue: false,
      message: '',
      purchasedMessage: '',
      listingExhaustedmessage: '',
      writeP: AppConstants.defaultRead,
      selectedType: '',
      selectedTypeValue: '',
      showDropDown: false,
      subscription_types_list: [
        {
          label: 'Stripe',
          value: 'stripe',
        },
        {
          label: 'Mangopay',
          value: 'mangopay',
        },
        {
          label: 'Android',
          value: 'android',
        },
        {
          label: 'iOS',
          value: 'ios',
        },
        {
          label: 'Free Subscription',
          value: 'free_subscription',
        },
      ],
      ...this.savedDraft,
    };
  }
  t = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  persistDraft = () => writeSubscriptionConfigDraft(this.draftKey, this.state);
  componentDidUpdate() {
    if (this.draftReady) this.persistDraft();
  }
  static propTypes = {
    backBtn: PropTypes.func,
    saveBtnCB: PropTypes.bool,
  };
  componentDidMount() {
    this.loadConfigApi();
  }

  //MARK:-  APIs Method 
  loadConfigApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config + `?key_group=${KeyGroup}`,
      'get',
      '',
      '',
    );
    if (responseJson['status'] == true) {
      var configs = responseJson['data']['configs'];
      this.setState({
        switchValue: configs['subscription_enabled'] || false,
        message: configs['subscription_not_active_message'] || '',
        purchasedMessage:
          configs['subscription_already_purchased_message'] || '',
        listingExhaustedmessage:
          configs['subscription_allow_listings_exhausted_message'] || '',
        selectedType:
          this.state.subscription_types_list.find(
            it => it.value == configs['subscription_type'],
          )?.label ?? '',
        selectedTypeValue: configs['subscription_type_value'] || '',
        ...this.savedDraft,
      }, () => {
        this.draftReady = true;
        this.persistDraft();
      });
    } else {
      this.setState({dataLoad: true, ...this.savedDraft}, () => {
        this.draftReady = true;
        this.persistDraft();
      });
    }
  };
  addOrUpdateAppDetailApi = async filesData => {
    var configs = [];
    let valueArray = [
      this.state.switchValue,
      this.state.message,
      this.state.selectedTypeValue,
      this.state.purchasedMessage,
      this.state.listingExhaustedmessage,
    ];
    // var configs = [];
    for (let i = 0; i < keysArray.length; i++) {
      if (valueArray[i].length != 0) {
        let fDict = {
          key_group: KeyGroup,
          key: keysArray[i],
          value: valueArray[i],
          secured: i == 0 || i == 2 ? false : true,
        };
        configs.push(fDict);
      }
    }

    if (
      this.state.selectedTypeValue == 'stripe' ||
      this.state.selectedTypeValue == 'paydunya'
    ) {
      configs.push({
        key_group: KeyGroup,
        key: 'subscription_payment_gateway',
        value: this.state.selectedTypeValue,
        secured: false,
      });
    }

    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config,
      'post',
      JSON.stringify({configs: configs}),
    );
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      revenuModelMixPanelEvent(MixpanelEvent.accountSubscription);
      clearSubscriptionDraft(this.draftKey);
      this.draftReady = false;
      this.props.onCloseModal();
      this.deleteKeysAPI(configs);
    } else {
      this.setState({dataLoad: true});
      this.alertView(responseJson);
    }
  };
  deleteKeysAPI = async Parameter => {
    var deleteParms = [];
    for (let q = 0; q < keysArray.length; q++) {
      deleteParms.push(keysArray[q]);
    }
    for (let a = 0; a < Parameter.length; a++) {
      let name = Parameter[a]['key'];
      let index = deleteParms.indexOf(name);
      deleteParms.splice(index, 1);
    }
    let parms = deleteParms.toString();
    let urlParm = APPURL.URLPaths.config + '?key=' + parms;
    const responseJson = await networkService.networkCall(urlParm, 'delete');
    this.setState({dataLoad: true});
    this.alertView(this.t('subscriptions.config.saved', 'Subscription settings saved successfully'));
  };
  alertView(title) {
    if (Platform.OS === 'web') {
      AppToast('info', title);
    } else {
      Alert.alert(title);
    }
  }
  didSelectDropDown = item => {
    console.log('index', item);
    this.setState({
      showDropDown: !this.state.showDropDown,
      selectedTypeValue: item['value'],
      selectedType: item['label'],
    });
  };
  //MARK:-  Buttons Action Method 
  saveButtonAction() {
    this.setState({dataLoad: false});
    this.addOrUpdateAppDetailApi();
  }

  //
  customDropDown = id => {
    if (this.state.showDropDown == true) {
      return (
        <View style={CommonStyleSheet.showDropDownViewStyle}>
          <FlatList
            data={this.state.subscription_types_list}
            horizontal={false}
            renderItem={this.renderDropDown}
            extraData={this.state}
            showsVerticalScrollIndicator={true}
            alwaysBounceVertical={true}
            scrollEnabled={true}
          />
        </View>
      );
    }
    return <View></View>;
  };
  renderDropDown = ({item, index}) => {
    return (
      <TouchableOpacity
        onPress={() => this.didSelectDropDown(item, index)}
        style={{margin: 5, height: 30, marginBottom: 5}}>
        <View style={{justifyContent: 'center', width: '100%'}}>
          <Text style={CommonStyleSheet.dropdownCellItemTextStyle}>
            {this.t(`subscriptions.type.${item.value}`, item.label)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };
  renderValueLabel = () => {
    return (
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Text
          style={
            this.state.selectedType == ''
              ? appConfigStyle.placeholderTxtStyle
              : appConfigStyle.txtFieldStyleDropDown
          }>
          {this.state.selectedType == ''
            ? this.t('subscriptions.form.select_type', 'Select Type')
            : this.t(`subscriptions.type.${this.state.selectedTypeValue}`, this.state.selectedType)}
        </Text>
        <Image
          style={
            this.state.showDropDown == true
              ? appConfigStyle.upArraowIconStyle
              : appConfigStyle.downArraowIconStyle
          }
          resizeMode="contain"
          source={downArrow_Icon}
        />
      </View>
    );
  };
  //MARK:-  UIs 
  render() {
    return (
      <View
        style={{
          width: '100%',
          paddingTop: 10,
        }}>
        <HeaderView
          title={this.t('subscriptions.account_title', 'Account Subscription')}
          saveBtnTitle={this.t('common.save', 'Save')}
          saveBtn={() => this.saveButtonAction()}
          backBtn={() => { this.draftReady = false; clearSubscriptionDraft(this.draftKey); this.props.onCloseModal(); }}
        />
        <View
          style={{
            margin: 10,
          }}
        />
        <Text style={appConfigStyle.subTitleStyle}>
          {this.t('subscriptions.config.description', 'Manage account subscriptions. When enabled, account owners need an active subscription to post listings. The default payment gateway selected in Payment Method is used for subscription payments.')}
        </Text>
        <View style={appConfigStyle.horizontalLineViewStyle} />
        <View style={appConfigStyle.subViewStyle}>
          <View style={{flexDirection: 'column', flex: 1.5}}>
            <View style={{marginTop: -30}}>
              <View style={{flexDirection: 'row'}}>
                <Switch
                  onColor={colors.AppNewGreen}
                  onChange={() =>
                    this.setState({switchValue: !this.state.switchValue})
                  }
                  checked={this.state.switchValue}
                  height={22}
                  width={50}
                />
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Text style={appConfigStyle.statusTxtStyle}>
                    {this.t('subscriptions.config.enable', 'Enable subscriptions')}
                  </Text>
                </View>
              </View>
            </View>
            <View
              style={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                marginTop: 20,
                zIndex: 9999999,
              }}>
              <Text style={appConfigStyle.titleTxtStyle}>
                {this.t('subscriptions.config.type', 'Subscription type')}
              </Text>
              <TouchableOpacity
                style={[CommonStyleSheet.dropDownViewStyle, {width: '100%'}]}
                onPress={() =>
                  this.setState({showDropDown: !this.state.showDropDown})
                }>
                <this.renderValueLabel />
                <this.customDropDown />
              </TouchableOpacity>
            </View>
            <View style={{marginTop: 30}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                {this.t('subscriptions.config.purchased_message', 'Message when a subscription is already purchased')}
              </Text>
              <TextInput
                style={[appConfigStyle.txtFieldStyle, {outline: 0}]}
                placeholder={this.t('subscriptions.config.purchased_placeholder', 'Enter the already-purchased message')}
                placeholderTextColor={colors.placeholderColor}
                onChangeText={name => this.setState({purchasedMessage: name})}
                value={this.state.purchasedMessage}
              />
            </View>
            <View style={{marginTop: 20}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                {this.t('subscriptions.config.listings_exhausted_message', 'Message when the listing limit is reached')}
              </Text>
              <TextInput
                style={[appConfigStyle.txtFieldStyle, {outline: 0}]}
                placeholder={this.t('subscriptions.config.listings_exhausted_placeholder', 'Enter the listing limit message')}
                placeholderTextColor={colors.placeholderColor}
                onChangeText={name =>
                  this.setState({listingExhaustedmessage: name})
                }
                value={this.state.listingExhaustedmessage}
              />
            </View>
            <View style={{marginTop: 20}}>
              <Text style={appConfigStyle.titleTxtStyle}>
                {this.t('subscriptions.config.inactive_message', 'Message when the subscription is inactive')}
              </Text>
              <TextInput
                style={[appConfigStyle.txtFieldStyle, {outline: 0}]}
                placeholder={this.t('subscriptions.config.inactive_placeholder', 'Enter the inactive subscription message')}
                placeholderTextColor={colors.placeholderColor}
                onChangeText={name => this.setState({message: name})}
                value={this.state.message}
              />
            </View>
          </View>
        </View>
        <View style={{height: 220}} />
        <Appload enable={this.state.dataLoad} />
      </View>
    );
  }
}
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: 'white',
  },
});

let keysArray = [
  'subscription_enabled',
  'subscription_not_active_message',
  'subscription_type',
  'subscription_already_purchased_message',
  'subscription_allow_listings_exhausted_message',
];

export default withLocale(Subscription);
